import { render, staticRenderFns } from "./ProductSupplierDetails.vue?vue&type=template&id=c60af0ae&scoped=true&"
import script from "./ProductSupplierDetails.vue?vue&type=script&lang=js&"
export * from "./ProductSupplierDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductSupplierDetails.vue?vue&type=style&index=0&id=c60af0ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60af0ae",
  null
  
)

export default component.exports